exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-title[data-v-1c5d57d0]{border-bottom:3px solid #eeeff2;padding-bottom:20px}.card-link[data-v-1c5d57d0]{color:#000}.circle-pic[data-v-1c5d57d0]{border-radius:50%;height:100%;width:100%;filter:grayscale(100%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c5d57d0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Service.vue
// module id = 342
// module chunks = 0